exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-create-sync-doc-24crA{vertical-align:top}.index-local-file-sync-tooltip-3d78v{display:block}.index-local-file-sync-9NmTb{vertical-align:top;justify-content:center;width:28px;height:28px;border-radius:2px;cursor:default}.index-local-file-sync-9NmTb:hover{background-color:rgba(0,0,0,.04)}.index-local-file-sync-disabled-3nxhc{cursor:not-allowed!important;opacity:.3!important}.index-local-file-sync-9NmTb{display:flex;align-items:center}", ""]);

// Exports
exports.locals = {
	"create-sync-doc": "index-create-sync-doc-24crA",
	"local-file-sync-tooltip": "index-local-file-sync-tooltip-3d78v",
	"local-file-sync": "index-local-file-sync-9NmTb",
	"local-file-sync-disabled": "index-local-file-sync-disabled-3nxhc"
};